import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const atelierSentText = (t, v, code) => t("atelier.sentMsg", { v, b: code || "?" });

// « Envoyé à l'atelier — vX (build Y). L'ancienne version reste en ligne » + link to the Atelier item.
export const AtelierSent = ({ v, code, id, testId = "atelier-sent" }) => {
  const { t } = useI18n();
  return (
    <span className="inline-flex min-w-0 flex-wrap items-center gap-x-2 font-semibold text-amber-200" data-testid={testId}>
      <Wrench className="h-3.5 w-3.5 shrink-0" /> {atelierSentText(t, v, code)}
      {id && <Link to={`/admin/atelier?item=${id}`} className="underline" data-testid={`${testId}-link`}>{t("atelier.openItem")}</Link>}
    </span>
  );
};
